export const MAILBOX_DELEGATION_ACTIONS = {
  ADD: 'add',
  REMOVE: 'remove',
}

export const MAILBOX_DELEGATION_RIGHTS = [
  {
    key: 'readAndManage',
    messageId: 'ENGAGE.MAILBOX_DELEGATIONS.READ_AND_MANAGE',
    defaultMessage: 'Read and manage',
    headingMessageId: 'ENGAGE.MAILBOX_DELEGATIONS.READ_AND_MANAGE_HEADING',
    headingDefaultMessage: 'These users read and manage this mailbox',
  },
  {
    key: 'sendAs',
    messageId: 'ENGAGE.MAILBOX_DELEGATIONS.SEND_AS',
    defaultMessage: 'Send As',
    headingMessageId: 'ENGAGE.MAILBOX_DELEGATIONS.SEND_AS_HEADING',
    headingDefaultMessage: 'These users send email as this mailbox',
  },
  {
    key: 'sendOnBehalf',
    messageId: 'ENGAGE.MAILBOX_DELEGATIONS.SEND_ON_BEHALF',
    defaultMessage: 'Send on Behalf',
    headingMessageId: 'ENGAGE.MAILBOX_DELEGATIONS.SEND_ON_BEHALF_HEADING',
    headingDefaultMessage: 'These users send on behalf of this mailbox',
  },
]
